class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    // Define 'select' as a class property
    this.selectElement = document.getElementById("SortBy");
    // this.initializeSelect();
    
    const facetForm = this.querySelector("form");
    // facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));
    facetForm.addEventListener("input", (event) => {
      this.onSubmitHandler(event);
      $('#hdnLoadMoreBtn').click();
    });

    const facetWrapper = this.querySelector("#FacetsWrapperDesktop");
    if (facetWrapper) facetWrapper.addEventListener("keyup", ()=>{});

    let dropdownContainer = document.getElementById("customDropdown");

    // Check if the "customDropdown" element exists
    if (dropdownContainer) {
      facetForm.addEventListener("click", (event) => {
        if (event.target.tagName === "LI") {
          this.updateSelectAndClose(event);
        }
      });

      facetForm.addEventListener("click", (event) => {
        if (event.target.id === "labelSortBy") {
          this.openDropDown();
        }
      });
    }


    $('.twoImageDescription, .prdfilter ').on('click', ()=> {
      if($('#customDropdown').hasClass('slideDown') && $('#customDropdown').hasClass('open')) {
       $('#customDropdown').slideUp(500);
       $('#customDropdown').addClass('slideUp');
       $('#customDropdown').removeClass('slideDown');
       $('#customDropdown').removeClass('open');
      }
   });


   $(".filter_overlay").on('click', () => {
    $('#customDropdown').slideUp(500);
    $('#customDropdown').addClass('slideUp');
    $('#customDropdown').removeClass('slideDown');
    $('#customDropdown').removeClass('open');
    $('body').removeClass('overflow');
    $(".filter_overlay").removeClass('active');
   });
  }

  

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state
        ? event.state.searchParams
        : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
      $('#hdnLoadMoreBtn').click();
    };
    window.addEventListener("popstate", onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll(".js-facet-remove").forEach((element) => {
      element.classList.toggle("disabled", disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById("ProductCount");
    const countContainerDesktop = document.getElementById(
      "ProductCountDesktop"
    );
    document
      .getElementById("ProductGridContainer")
      .querySelector(".collection")
      .classList.add("loading");
    if (countContainer) {
      countContainer.classList.add("loading");
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add("loading");
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
      
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
    
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        
        FacetFiltersForm.filterData = [
          ...FacetFiltersForm.filterData,
          { html, url },
        ];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      })
      .then((response) => {
        
        initButtons();
        initGrid();
      });
    
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    initButtons();
    initGrid();
  }

  static renderProductGridContainer(html) {
    document.getElementById("ProductGridContainer").innerHTML = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("ProductGridContainer").innerHTML;
    endlessDiv = new Ajaxinate({
  container: '#loadMoreDiv',
  pagination: '#loadMore-Pagination',
  loadingText:''
  });
  }

  static renderProductCount(html) {
    const count = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("ProductCount").innerHTML;
    const container = document.getElementById("ProductCount");
    const containerDesktop = document.getElementById("ProductCountDesktop");
    container.innerHTML = count;
    container.classList.remove("loading");
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove("loading");
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, "text/html");

    const facetDetailsElements = parsedHTML.querySelectorAll(
      "#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter"
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest(".js-filter") : undefined;
      return jsFilter
        ? element.dataset.index === jsFilter.dataset.index
        : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter(
      (element) => !matchesIndex(element)
    );
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(
        `.js-filter[data-index="${element.dataset.index}"]`
      ).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender)
      FacetFiltersForm.renderCounts(
        countsToRender,
        event.target.closest(".js-filter")
      );
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = [
      ".active-facets-mobile",
      ".active-facets-desktop",
    ];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML =
        activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = [
      ".mobile-facets__open",
      ".mobile-facets__count",
      ".sorting",
    ];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML =
        html.querySelector(selector).innerHTML;
    });

    document
      .getElementById("FacetFiltersFormMobile")
      .closest("menu-drawer")
      .bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector(".facets__selected");
    const sourceElement = source.querySelector(".facets__selected");

    const targetElementAccessibility = target.querySelector(".facets__summary");
    const sourceElementAccessibility = source.querySelector(".facets__summary");

    if (sourceElement && targetElement) {
      target.querySelector(".facets__selected").outerHTML =
        source.querySelector(".facets__selected").outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector(".facets__summary").outerHTML =
        source.querySelector(".facets__summary").outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      "",
      `${window.location.pathname}${searchParams && "?".concat(searchParams)}`
    );
  }

  static getSections() {
    return [
      {
        section: document.getElementById("product-grid").dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);

    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    // alert(1);
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll(
      "facet-filters-form form"
    );
    if (event.srcElement.className == "mobile-facets__checkbox") {
      const searchParams = this.createSearchParams(
        event.target.closest("form")
      );
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile =
        event.target.closest("form").id === "FacetFiltersFormMobile";

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (
            form.id === "FacetSortForm" ||
            form.id === "FacetFiltersForm" ||
            form.id === "FacetSortDrawerForm"
          ) {
            const noJsElements = document.querySelectorAll(".no-js-list");
            noJsElements.forEach((el) => el.remove());
            console.log(this.createSearchParams(form));
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === "FacetFiltersFormMobile") {
          forms.push(this.createSearchParams(form));
        }
      });
       
      this.onSubmitForm(forms.join("&"), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf("?") == -1
        ? ""
        : event.currentTarget.href.slice(
            event.currentTarget.href.indexOf("?") + 1
          );
    FacetFiltersForm.renderPage(url);
  }

  // updateSelectAndClose(event) {
  //   console.log(event);
  //   const selectedValue = event.target.getAttribute("data-value");

  //   this.selectElement.value = selectedValue;
  //   $("#SortBy option[value='" + selectedValue + "']").prop("selected", true);

  //   console.log("Selected Value:", this.selectElement.value); // Debugging statement
  //   // Trigger the 'change' event on the <select> element
  //   const changeEvent = new Event("change", {
  //     bubbles: true,
  //     cancelable: false,
  //   });
  //   this.selectElement.dispatchEvent(changeEvent);

  //   this.onSubmitHandler(event);
  // }
  
  updateSelectAndClose(event) {
    // console.log(event.target);
    let currentTarget = event.target;
    const label = document.querySelector('.select label');
    const selectedValue = event.target.getAttribute("data-value");
    const selectText = event.target.textContent;
    this.selectElement.value = selectedValue;
    $("#SortBy option[value='" + selectedValue + "']").prop("selected", true); // Updated line
    
    // event.target.classList.add('selected');
    
     // currentTarget.style.backgroungColor = '#000';
    
    // Trigger the 'change' event on the <select> element

    const changeEvent = new Event("change", {
      bubbles: true,
      cancelable: false,
    });
    this.selectElement.dispatchEvent(changeEvent);
  
    this.onSubmitHandler(event);
    $('#customDropdown').slideUp(500);
    $('#customDropdown').addClass('slideUp');
    $('#customDropdown').removeClass('slideDown');
    $('#customDropdown').removeClass('open');
    $('body').removeClass('overflow');
    $(".filter_overlay").removeClass('active');
    let $this = $(event.target);
    setTimeout(() => {
      console.log($this);
      // label.textContent = selectText;
     $('#customDropdown li').css({'background-color': '#fff', 'color': '#000'});
      $('#customDropdown li').removeClass('selected')
      $('.select label').text(selectText);
      $('.facets__form').attr('data-selected', selectedValue);
      $(`#customDropdown li[data-value="${selectedValue}"]`).css({'background-color':'#000', 'color': '#fff'});
      console.log("Selected Text:", selectText, label.textContent); // Debugging statement
    }, 1000)
    
  }

  openDropDown() {
    const customUl = document.getElementById('customDropdown');
    const currentCustomUltHeight = customUl.clientHeight;

    if($('#customDropdown').hasClass('slideUp')) {
      $('#customDropdown').slideDown(500);
      $('#customDropdown').addClass('slideDown');
      $('#customDropdown').removeClass('slideUp');
      $('body').addClass('overflow');
      $(".filter_overlay").addClass('active');
      // setTimeout(() => {
      //   $('#customDropdown').addClass('open');
      // }, 1000);
    }
  }


  
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define("facet-filters-form", FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll("input").forEach((element) =>
      element.addEventListener("change", this.onRangeChange.bind(this))
    );
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
    $('#hdnLoadMoreBtn').click();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll("input");
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute("max", maxInput.value);
    if (minInput.value) maxInput.setAttribute("min", minInput.value);
    if (minInput.value === "") maxInput.setAttribute("min", 0);
    if (maxInput.value === "")
      minInput.setAttribute("max", maxInput.getAttribute("max"));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute("min"));
    const max = Number(input.getAttribute("max"));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define("price-range", PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector("a");
    facetLink.setAttribute("role", "button");
    facetLink.addEventListener("click", this.closeFilter.bind(this));
    facetLink.addEventListener("keyup", (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === "SPACE") this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form =
      this.closest("facet-filters-form") ||
      document.querySelector("facet-filters-form");
    form.onActiveFilterClick(event);
    $('#hdnLoadMoreBtn').click();
  }
  
}

customElements.define("facet-remove", FacetRemove);
